import { useEffect, useState } from "react";

function getActiveSection(sectionIds) {
  const scrollPosition = window.scrollY + 220;

  for (let index = sectionIds.length - 1; index >= 0; index -= 1) {
    const section = document.getElementById(sectionIds[index]);

    if (!section) {
      continue;
    }

    if (scrollPosition >= section.offsetTop) {
      return sectionIds[index];
    }
  }

  return sectionIds[0] ?? "hero";
}

export default function useLandingPageUi(sectionIds) {
  const [activeSection, setActiveSection] = useState(sectionIds[0] ?? "hero");
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    document.body.classList.add("index-page");

    return () => {
      document.body.classList.remove("index-page");
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      document.body.classList.toggle("scrolled", window.scrollY > 100);
      setShowScrollTop(window.scrollY > 240);
      setActiveSection(getActiveSection(sectionIds));
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.body.classList.remove("scrolled");
    };
  }, [sectionIds]);

  useEffect(() => {
    document.body.classList.toggle("mobile-nav-active", isMobileNavOpen);

    return () => {
      document.body.classList.remove("mobile-nav-active");
    };
  }, [isMobileNavOpen]);

  useEffect(() => {
    if (!window.AOS) {
      return undefined;
    }

    window.AOS.init({
      duration: 600,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });

    const refreshId = window.setTimeout(() => {
      window.AOS.refreshHard?.();
      window.AOS.refresh?.();
    }, 50);

    return () => window.clearTimeout(refreshId);
  }, []);

  const handleNavClick = (sectionId) => {
    const section = document.getElementById(sectionId);
    setIsMobileNavOpen(false);
    setActiveSection(sectionId);

    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const toggleMobileNav = () => {
    setIsMobileNavOpen((currentValue) => !currentValue);
  };

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return {
    activeSection,
    handleNavClick,
    handleScrollTop,
    isMobileNavOpen,
    showScrollTop,
    toggleMobileNav,
  };
}
